












































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
// import { TransferTransaction, Message, PublicAccount } from 'nem2-sdk';
import DynamicDivider from '@/components/DynamicDivider.vue';
import MobileDetectionMixin from '@/assets/ts/mixins/MobileDetectionMixin';
import { IAssetInfo } from '@/store/modules/asset/interface';

import {VerifyInfo } from '@luxtag/papybase';
import {clone} from 'lodash';

@Component({
    components: {
        DynamicDivider,
    },
})
export default class CertificateInformation extends Mixins(MobileDetectionMixin) {
    @Prop({ default: false }) public carouselTopRadius!: boolean;
    @Prop() public assetAccount!: any | null;
    @Prop() public verifyInfo!: VerifyInfo | null;
    @Prop({ default: '' }) public merchant!: string;

    get assetInfo(): IAssetInfo | undefined {
        if (this.assetAccount) {
            return this.$store.getters.getAssetCreationInfoByPublicKey(this.assetAccount.publicKey);
        } else {
            return;
        }
    }

    get certIssuer(): string {
        return this.merchant;
    }

    get certImgs(): string[] {
        if (this.verifyInfo) {
            if (this.verifyInfo.payload.data.img) {
                return [this.verifyInfo.payload.data.img];
            }
        }

        return [];
    }

    // get certTag() {
    //      if (this.assetInfo) {
    //         return this.assetInfo.message.id;
    //     } else {
    //         return '';
    //     }
    // }

    get certContent() {
        if (this.verifyInfo) {
            const clonedData = clone(this.verifyInfo.payload.data);
            delete clonedData.img;
            return clonedData;
        } else {
            return {};
        }
    }
}
